<template lang="pug">
  .chat__group
    v-layout(justify-end, align-center)
      .selected_items__action(v-if="selectedContacts.length > 1", @click="createGroup") {{ $t('actions.createGroup') }}
      .selected_items__action.cancel(@click="$emit('cancelGroupCreation')") {{ $t('actions.cancel') }}
    .chat__group__errors(v-if="grouChatCreationErrors && grouChatCreationErrors.length")
      .msg_error(v-for="(message, index) in grouChatCreationErrors", :key="'chat_err_' + index") {{ message }}
    .selected_items(v-if="selectedContacts.length")
      .list_item__wrap
        .list_item(v-for="contact in selectedContacts", :key="'selected_' + contact.id")
          .list_item__preview
            div(v-if="contact.avatar_url", :style="{ 'background-image': 'url(' + contact.avatar_url + ')' }")
            AvatarPlaceholder.xs(v-else, :fullName="contact.first_name + ' ' + contact.last_name", :classname="getAvatarClass(contact.first_name, contact.last_name)")
          .list_item__name {{ contact.first_name }} {{ contact.last_name }}
    .selected_items(v-else)
      .selected_items__empty {{ $t('hints.whomWouldYouLikeToMessage') }}
    .group_items__list
      MessagesGroupListItem(
        v-for="(item, index) in contacts",
        :key="'group_' + index",
        :contact="item",
        :selected="isContactSelected(item.id)",
        @onContactCheck="toggleSelected")
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MessagesGroupListItem from '@/components/MessagesGroupListItem';
import AvatarPlaceholder from '@/components/AvatarPlaceholder';
import { getAvatarClass } from '@/utils';

export default {
  components: { MessagesGroupListItem, AvatarPlaceholder },
  data() {
    return {
      getAvatarClass,
      selectedContacts: []
    };
  },
  computed: {
    ...mapState('user', [
      'grouChatCreationErrors'
    ]),
    ...mapGetters('chats', {
      contacts: 'getContactsFromPrivateChats'
    }),
    authUser() {
      return this.$store.state.user;
    }
  },
  methods: {
    toggleSelected(contactId) {
      const checkedIndex = this.selectedContacts.findIndex(i => i.id === contactId);

      if (checkedIndex !== -1) {
        this.selectedContacts.splice(checkedIndex, 1);
      } else {
        const checked = this.contacts.find(i => i.id === contactId);
        this.selectedContacts.push(checked);
      }
    },
    isContactSelected(contactId) {
      return !!this.selectedContacts.find(i => i.id === contactId);
    },
    createGroup() {
      if (this.selectedContacts.length <= 1) return;

      const users = this.selectedContacts.map(contact => ({ id: contact.id }));
      // TODO: Pass chat title as design for creation is provided
      const data = { title: `Chat of ids: ${this.authUser.id}, ${users.map(i => i.id).join(', ')}`, users };

      this.$emit('clickCreate', data);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .chat__group {
    height: 100%;
    overflow: auto;

    .group_items__list {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 100%;
      max-height: calc(100% - 71px);
    }

    .selected_items {
      margin-bottom: 17px;
      display: flex;
      justify-content: space-between;
      background: $grey-light4;
      border-radius: 25px;
      padding: 0 16px;
      position: sticky;
      top: 0;
      z-index: 2;

      &__empty {
        line-height: normal;
        font-size: 16px;
        padding: 10px 0;
        font-weight: 600;
        color: $grey-text;
      }

      &__action {
        display: inline-block;
        font-size: 16px;
        text-align: right;
        padding: 13px 0 7px;
        line-height: normal;
        color: $blue;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        margin-left: 15px;

        &.cancel {
          color: $error-color;
          display: none;
        }
      }

      .list_item {
        display: flex;
        align-items: flex-end;
        margin-right: 26px;
        padding: 8px 0;
        cursor: pointer;

        &__wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }

        &__preview > div {
          width: 24px;
          min-width: 24px;
          height: 24px;
          margin-right: 7px;
          border-radius: 50%;
          background-size: cover;
          background-position: center;
        }

        &__name {
          font-size: 16px;
          line-height: normal;
          font-weight: 600;
          color: $sub-black;
        }
      }
    }

    &__errors {
      text-align: left;
      font-size: 12px;
      margin: 10px 0;

      .msg_error { color: $error-color; }
    }
  }

  @media screen and (max-width: 1024px) {
    .cancel { display: inline-block !important; }
  }
</style>
